<template>
  <div class="p-content">
    <!-- 轮播 -->
    <div class="lunbo" v-if="$route.meta.banner">
      <a-carousel dotsClass="dot" autoplay>
        <div v-for="(item,i) in banner" :key="i">
          <a :href="item.link"><img :src="'http://'+item.image_file"></a>
        </div>
      </a-carousel>
    </div>
    <!-- 分类 -->
    <div class="tab">
      <div>
        <a-tabs :default-active-key="0" tabPosition="top" @tabClick="callback">
          <a-tab-pane v-for="(item,i) in productClass" :key="i" :tab="[$store.state.langStates == 'zh' ? item.category_name:item.category_name_en]">
            <div class="tab_content main-center">
              <div class="tab_info text-center" v-for="(pitem,index) in productList" :key="index" :style="{'margin-right':(index+1==productList.length)&&((index-1)%3==0)?'calc(34.4%)':''}">
                <router-link :to="{path:'/pDetails',query:{uuid:pitem.uuid}}">
                  <div class="img">
                    <img :src="'http://' + [$store.state.langStates == 'zh' ? pitem.image_head_file:pitem.image_head_file_en]">
                  </div>
                  <div class="main-font18" style="color: #101010;" v-if="$store.state.langStates == 'zh'">{{pitem.category}} {{pitem.series}} {{pitem.name}}</div>
                  <div class="main-font18" style="color: #101010;" v-else>{{pitem.category_en}} {{pitem.series_en}} {{pitem.name_en}}</div>
                  <div class="">
                    <div>
                      <a-button type="primary" :block="true">{{$t('title.downloadCenter')}}</a-button>
                    </div>
                    <div>
                      <a-button type="primary" :block="true">{{$t('title.xxcs')}}</a-button>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination size="small" :total="info.total" :show-total="total => `${$t('title.total')} ${info.last_page} ${$t('title.pages')}`"
          :defaultPageSize="12" @change="onChange" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        productClass: '',
        productList: [],
        str: '',
        info: {
									last_page:0
								},
        name: '',
        banner: ''
      };
    },
    created() {
      this.init(this.$store.state.langStates)
    },
    destroyed() {
      sessionStorage.removeItem("searchKey")
    },
    watch: {
      "$route": {
        handler(route) {
          const that = this
          if (route.name === '/product') {
            that.init(that.$store.state.langStates)
          }
        }
      },
      '$store.state.langStates': function(val) {
        this.init(val)
      }
    },
    methods: {
      callback(val) {
        var lang = this.$store.state.langStates
        if (lang == 'zh') {
          this.name = this.productClass[val].category_name
          this.getList(lang, this.str, 1)
        } else {
          this.name = this.productClass[val].category_name_en
          this.getList(lang, this.str, 1)
        }
      },
      init(lang) {
        this.$api.dongjuapi.categories(lang).then(res => {
          this.productClass = res.data.data
          if (this.$store.state.langStates == 'zh') {
            this.name = res.data.data[0].category_name
          } else {
            this.name = res.data.data[0].category_name_en
          }
          this.str = sessionStorage.getItem('searchKey')
          this.getList(lang, this.str, 1)
        }).catch(err => {

        })
        // 获取banner
        this.$api.dongjuapi.banner({
          type: 'product'
        }).then(res => {
          if (res.data.code == 200) {
            this.banner = res.data.data
          }
        })
      },
      // 产品列表
      getList(lang, str, p) {
        if (str) {
          this.$api.dongjuapi.products({
            lang,
            name: str,
            limit: 12,
            page: p
          }).then(r => {
            this.info = r.data.data
            this.productList = r.data.data.data
          }).catch(err => {

          })
          this.str = ""
        } else {
          this.$api.dongjuapi.products({
            lang,
            category_name: this.name,
            limit: 12,
            page: p
          }).then(r => {
            this.info = r.data.data
            this.productList = r.data.data.data
          }).catch(err => {

          })
        }
      },
      onChange(current) {
        this.getList(this.$store.state.langStates, this.str, current)
      },
    },
  };
</script>

<style lang="less">
  .p-content {
    .tab {
      width: 100%;
      background: #F1F1F1;

      .ant-tabs-bar {
        color: #fff;
        height: 90px;
        background: #1E2986 !important;
        font-size: 18px;
        border-bottom: 10px solid #F1F1F1;
        padding: 0 110px;
        margin: 0;
      }

      .ant-tabs-nav {
        border-bottom: 10px solid #F1F1F1;

        .ant-tabs-tab-active {
          color: #fff;
          border: none;
        }

        .ant-tabs-tab {
          height: 90px;
          line-height: 56px;
          margin: 0 40px;
        }
      }

      .ant-tabs-nav-scroll {
        overflow: visible;
        overflow-x: hidden;
      }

      .ant-tabs-ink-bar {
        background: #f1f1f1;

        &::before {
          content: '';
          position: absolute;
          width: 0px !important;
          height: 0px;
          font-size: 0;
          line-height: 0;
          border-width: 7px;
          border-style: solid dashed dashed dashed;
          border-color: #1E2986 transparent transparent transparent;
          background: transparent;
          bottom: -5px;
          left: 0;
          right: 0;
          margin: auto;
        }
      }

      .ant-tabs-nav-wrap {
        margin-bottom: -10px;
      }

      .ant-tabs-tab-prev.ant-tabs-tab-arrow-show,
      .ant-tabs-tab-next.ant-tabs-tab-arrow-show {
        width: 40px;
        height: 89%;

        span {
          width: 40px;
          height: 40px;
          background: #fff;
          color: #1E2986;
          border-radius: 50%;
        }
      }

      .ant-tabs-tab-prev-icon-target,
      .ant-tabs-tab-next-icon-target {
        line-height: 40px;
        font-size: 30px;
        margin-top: 4px;
      }

      .tab_content {
        margin-top: 70px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .tab_info {
          // float: left;
          width: 31.25%;
          height: 490px;
          background: #fff;
          margin-bottom: 40px;
          /* 如果最后一行是2个元素 */
          .img {
            width: 100%;
            height: 320px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          div:nth-child(2) {
            width: 100%;
            height: 80px;
            line-height: 80px;
          }

          div:nth-child(3) {
            width: 100%;
            height: 91px;
            border-top: 1px solid #f1f1f1;
            border-radius: 0px 0px 2px 2px;
            margin-top: 1px;
            display: flex;
            align-items: center;
            justify-content: space-around;

            div {
              width: 160px;
            }
          }
        }
      }
    }

    #components-pagination-demo-mini {
      width: 1200px;
      margin: 0 auto;
      text-align: right;
      margin-top: 40px;
      margin-bottom: 40px;

      .ant-pagination-item-active {
        background: #746CAF;
        color: #fff;

        a {
          color: #fff;
        }
      }
    }
  }
</style>
